import Vue from "vue"
import Vuex from "vuex"
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    token: null,
    menuList: null, // 菜单列表
    userInfo: null, // 用户信息
    themeColor: "#A32126", // 默认主题色
    navMenuBgColor: "#A32126", // 默认导航菜单背景色
  },
  mutations: {
    setToken(state, token) {
      state.token = token
    },
    setMenuList(state, menuList) {
      state.menuList = menuList
    },
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    // 用于修改用户信息后的更新
    setUserInfoUpdate(state, payload) {
      if (typeof payload === "object" && payload !== null) {
        const hasOwn = Object.prototype.hasOwnProperty // 获取hasOwnProperty的原始引用
        for (const key in payload) {
          if (hasOwn.call(payload, key)) {
            state.userInfo[key] = payload[key]
          }
        }
      }
    },
    logout(state) {
      state.token = null
      state.menuList = null
      state.userInfo = null
    },
  },
  actions: {
    // 登出
    logout({ commit }) {
      commit("logout")
    },
    updateUserInfos({ commit }, updates) {
      commit("setUserInfoUpdate", updates)
    },
  },
  modules: {},
})
